import Constant from '@/constant'
import presentationGetters from './presentation'
import slideActiveGetters from './slideActive'
import currentUserGetters from './currentUser'
import currentTeamGetters from './currentTeam'
import pricingGetters from './pricing'
import surveyGetters from './survey'
import configs from '@/config'
import pageGetter from './pageGetter'
import slides from './slides'
import googleSlidesAddOnGetters from './googleSlidesAddOn'
import * as plan from './plan'
import { ROUTE_NAMES } from '@/constant/routes'
import powerpointGetters from './powerpoint'

const getSlideOptionsActive = (state) => {
  return state.slideActive.SlideOptions
}
const getSelectedSlides = (state) => {
  const selected =
    state.selections.selectedSlideIds.length && state.selections.selectedSlideIds.some((id) => id !== null)
      ? state.selections.selectedSlideIds
      : [state.slideActive.id]

  return state.presentation.slides
    .filter((slide) => selected.some((id) => id === slide.id))
    .sort((a, b) => a.order - b.order)
}

const selectedFolder = (state) => {
  if (!state.folders || !state.folders.length) return undefined
  return state.folders.find((folder) => folder.folderId === state.selections.selectedFolderId)
}

const getPresenterLocale = (state) => {
  return state.presenterLocale || 'en'
}

// AHA-46429: single source of truth for "an export job is running" — used
// by editor header menus (disable Download items) and DownloadSlideSection
// (loading card). Both PDF and image share the same UI-blocking semantic.
const isExportingSlides = (state) => Boolean(state.loadingExportImage || state.loadingExportPdfV2)

export default {
  ...presentationGetters,
  ...slideActiveGetters,
  ...currentUserGetters,
  ...surveyGetters,
  ...pricingGetters,
  ...currentTeamGetters,
  ...pageGetter,
  ...slides,
  ...plan,
  ...googleSlidesAddOnGetters,
  ...powerpointGetters,
  getSlideOptionsActive,
  getPresenterLocale,
  isExportingSlides,
  selectedFolder,
  visibleSlides: (_, __, ___, rootGetters) => {
    return rootGetters['skipSlide/visibleSlides']
  },
  currentSlideIndex: (state, getters) => {
    const { visibleSlides } = getters
    return visibleSlides && visibleSlides.findIndex(
      (s) => s.id === state.slideActive.id,
    )
  },
  selectedSlides: (state) => {
    return getSelectedSlides(state)
  },
  selectedSlide: (state) => {
    return getSelectedSlides(state)
      .reduce((a, b) => {
        const c = {}
        Constant.commonSlideAttributes.forEach((prop) => {
          if (a[prop] === undefined) {
            c[prop] = b[prop]
          } else if (prop === 'backgroundImage' || prop === 'audioLink') {
            c[prop] = (a[prop] && a[prop].name) === (b[prop] && b[prop].name) ? b[prop] : null
          } else if (prop === 'backgroundImageCropperData') {
            c[prop] = a[prop] || b[prop]
          } else if (prop === 'visibility') {
            c[prop] = parseInt(a[prop], 10) === parseInt(b[prop], 10) ? parseInt(b[prop], 10) : 20
          } else {
            c[prop] = a[prop] === b[prop] ? b[prop] : null
          }
        })
        return c
      }, {})
  },

  abTestGroup: (state) => {
    return state.currentUser && state.currentUser.id % 4
  },
  isEURegion() {
    return configs.region === 'eu'
  },
  isStagingGlobal() {
    return configs.env === 'develop'
  },
  isCanaryGlobal() {
    return window.location.hostname === 'presenter2.ahaslides.com'
  },
  isProductionGlobal() {
    return window.location.hostname === 'presenter.ahaslides.com'
  },
  isStagingEU() {
    return window.location.hostname === 'presenter.dev.ahaslides.eu'
  },
  isCanaryEU() {
    return window.location.hostname === 'presenter2.ahaslides.eu'
  },
  isProductionEU() {
    return window.location.hostname === 'presenter.ahaslides.eu'
  },
  // eslint-disable-next-line no-unused-vars
  isPresentationEditorRoute: (_state) => (route) => {
    return route?.name === ROUTE_NAMES.PRESENTATION_DETAIL
  },

  hasPrevSlide(_, getters) {
    return getters.currentSlideIndex > 0
  },

  hasNextSlide(_, getters) {
    const { visibleSlides } = getters
    return visibleSlides && getters.currentSlideIndex < visibleSlides.length - 1
  },

  nextSlideId(_, getters) {
    const { visibleSlides } = getters
    return visibleSlides[getters.currentSlideIndex + 1]?.id
  },

  prevSlideId(_, getters) {
    const { visibleSlides } = getters
    return visibleSlides[getters.currentSlideIndex - 1]?.id
  },
}
